export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  balances: (state) => state.balances,
  list: (state) => state.list,
  supply: (state) => state.supply,
};
